import { useRef } from "react";
import { Field } from "formik";
import { InputGroup, Form, Button } from "react-bootstrap";

export function SetDateField({ name }) {
    const ref = useRef();
    return (
        <Field name={name}>
            {({ field, form, meta }) => (
                <div className="w-100">
                    <InputGroup>
                        <Form.Control
                            type="date"
                            value={field.value || ""}
                            onChange={(e) => form.setFieldValue(name, e.target.value)}
                            ref={ref}
                            onClick={() => ref.current?.showPicker()}
                        />

                        <Button
                            variant="outline-secondary"
                            onClick={() => form.setFieldValue(name, "")}
                        >
                            <i className="bi bi-x-lg" />
                        </Button>
                    </InputGroup>
                    {meta.touched && meta.error && (
                        <div className="text-danger">{meta.error}</div>
                    )}
                </div>
            )}
        </Field>
    );
}
